const MAX_GALLERY_IMAGES = 4;

function getGalleryImages(gallery) {
  return [...gallery.querySelectorAll('[data-product-wheel-gallery-image]')].slice(0, MAX_GALLERY_IMAGES);
}

function galleryIndexFromPointer(clientX, left, width, count) {
  if (width <= 0 || count < 1) return 0;
  const position = Math.max(0, Math.min((clientX - left) / width, 0.999999));
  return Math.floor(position * count);
}

function showGalleryImage(gallery, index) {
  getGalleryImages(gallery).forEach((image, imageIndex) => {
    image.classList.toggle('is-active', imageIndex === index);
  });
}

if (typeof document !== 'undefined') {
  document.addEventListener('mousemove', (event) => {
    const gallery = event.target instanceof Element && event.target.closest('[data-product-wheel-gallery]');
    if (!gallery) return;

    const images = getGalleryImages(gallery);
    if (images.length < 2) return;

    const rect = gallery.getBoundingClientRect();
    showGalleryImage(gallery, galleryIndexFromPointer(event.clientX, rect.left, rect.width, images.length));
  });

  document.addEventListener('mouseout', (event) => {
    const gallery = event.target instanceof Element && event.target.closest('[data-product-wheel-gallery]');
    if (!gallery || (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget))) return;
    showGalleryImage(gallery, 0);
  });
}

if (typeof module !== 'undefined') {
  module.exports = galleryIndexFromPointer;

  if (require.main === module) {
    const assert = require('node:assert/strict');
    assert.deepEqual(
      [
        galleryIndexFromPointer(0, 0, 300, 3),
        galleryIndexFromPointer(150, 0, 300, 3),
        galleryIndexFromPointer(300, 0, 300, 3),
      ],
      [0, 1, 2]
    );
  }
}
